var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_col"},[_c('div',{staticClass:"titleFont"},[_vm._v(_vm._s(_vm.title))]),_c('input',{staticClass:"basicInputStyle",attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.changeInput($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }